import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InformationTemplateComponent } from './information-template/information-template.component';
import {
  FORM_PROCESSOR_MAPPING,
  WORKFLOW_SERVICE_MAPPING,
  WORKFLOW_VARIABLE_MAPPING,
} from '@alf-nx-workspace/shared/utils';

import { SharedUiModule } from '@alf-nx-workspace/shared/ui';
import { MasterarbeitsanmeldungService } from './masterarbeitsanmeldung.service';
import { MasterarbeitsanmeldungVariablesSearchable } from './masterarbeitsanmeldung.variables';
import { MasterarbeitsanmeldungStartFormularProcessor } from './form-processors/masterarbeitsanmeldung.start-formular.processor';

@NgModule({
  providers: [
    { provide: FORM_PROCESSOR_MAPPING, useValue: MasterarbeitsanmeldungStartFormularProcessor, multi: true },
    { provide: WORKFLOW_SERVICE_MAPPING, useValue: MasterarbeitsanmeldungService, multi: true },
    { provide: WORKFLOW_VARIABLE_MAPPING, useValue: MasterarbeitsanmeldungVariablesSearchable, multi: true },
  ],
  imports: [CommonModule, SharedUiModule, InformationTemplateComponent],
})
export class MasteranmeldungModule {}
